module.exports = __webpack_public_path__ + "img/prio-eletric-small.e4ba3bd7.png";